import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';

import AppSidebarUserInfo from './AppSidebarUserInfo';

export default function AppSidebarUserContainer({userData, isOpen}:any) {
    const {picture} = userData;
    
    if (isOpen) {
        return <AppSidebarUserInfo userData={userData} />;
    }
    
    return (
        <Box className="user">
            <Avatar
                src={picture}
                alt="user avatar"
                className="user__avatar"
            />
        </Box>
    );
}
